import { createContext } from 'react';
import { FeatureFlagName } from '@/utils/featureFlags';

interface FeatureFlagsContextType {
  isFeatureEnabled: (featureName: FeatureFlagName) => boolean;
  areFeatureFlagsLoaded: boolean;
  didFeatureFlagsFail: boolean;
  retryFeatureFlags: () => void;
}

export const FeatureFlagsContext = createContext<FeatureFlagsContextType | undefined>(undefined);
